export default __webpack_public_path__ + "media/zurb/img/legacy/spur/contrast-33c1e4252f2063f53a0684640554114d.jpg";